import React from 'react';
import ReactMarkdown from 'react-markdown';

interface MarkdownProps {
  text: string;
}

const Markdown = ({ text }: MarkdownProps) => {
  return <ReactMarkdown linkTarget="_blank">{text}</ReactMarkdown>;
};

export default Markdown;
try {
    // @ts-ignore
    Markdown.displayName = "Markdown";
    // @ts-ignore
    Markdown.__docgenInfo = { "description": "", "displayName": "Markdown", "props": { "text": { "defaultValue": null, "description": "", "name": "text", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Markdown/Markdown.tsx#Markdown"] = { docgenInfo: Markdown.__docgenInfo, name: "Markdown", path: "src/shared/components/Markdown/Markdown.tsx#Markdown" };
}
catch (__react_docgen_typescript_loader_error) { }